import { render, staticRenderFns } from "./ckeditor.vue?vue&type=template&id=2615be1e&scoped=true&"
import script from "./ckeditor.vue?vue&type=script&lang=js&"
export * from "./ckeditor.vue?vue&type=script&lang=js&"
import style0 from "./ckeditor.vue?vue&type=style&index=0&id=2615be1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615be1e",
  null
  
)

export default component.exports